export const MAX_MESSAGE_LENGTH = 200;
export const MAX_MESSAGE_LENGTH_PREMIUM = 300;

export const getMessageLimit = (hasSubscription) => {
  return hasSubscription ? MAX_MESSAGE_LENGTH_PREMIUM : MAX_MESSAGE_LENGTH;
};
